export default __webpack_public_path__ + "static/media/users.f1734b43.svg";